export const getImageFile = (filepath) => {
  return `${process.env.REACT_APP_SERVER_API_URL}/public${filepath}`
}
export const getFile = (filepath) => {
  return `${process.env.REACT_APP_SERVER_API_URL}/files/storage/modules/${filepath}`
}